var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "6 -6 512 512",
    style: {
      enableBackground: "new 6 -6 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486,294.6c-8.7-31.1-37.3-52.8-69.7-52.8H320v-61.5c0-33-26.9-59.9-59.9-59.9h-25.6c-9,0-16.3,7.3-16.3,16.3V195 c0,26.7-10.5,53.9-29.5,76.7l-35,35.5l23.3,22.9l35.4-35.9c0.3-0.3,0.6-0.6,0.8-0.9c24.3-28.7,37.6-63.6,37.6-98.2V153h9.3 c15,0,27.2,12.2,27.2,27.2v77.9c0,9,7.3,16.3,16.3,16.3h112.7c17.7,0,33.4,11.9,38.3,29.3c1.2,4,1.3,8.7,0.1,13.8l-23.5,117.6 c-0.7,4.2-2.9,16.9-29.1,16.9H163.1v32.7h239.1c34.2,0,56.5-16.1,61.2-43.6l23.3-116.6C489.1,314.2,488.8,303.7,486,294.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.6,252.2H52c-9,0-16.3,7.3-16.3,16.3v221.1c0,9,7.3,16.3,16.3,16.3h111.7c9,0,16.3-7.3,16.3-16.3V268.5 C180,259.5,172.7,252.2,163.6,252.2z M147.3,473.3h-79V284.9h79V473.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbUp);
export default __webpack_public_path__ + "static/media/icon_thumb-up.67b091a4d046e82eda70b4ad30d225d7.svg";
export { ForwardRef as ReactComponent };